export const CircleArrow: React.FC<React.SVGAttributes<SVGSVGElement>> = (
  props
) => (
  <svg
    fill='none'
    viewBox='0 0 18 19'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M9 .5c4.972 0 9 4.028 9 9s-4.028 9-9 9-9-4.028-9-9 4.028-9 9-9zM7.951 5.711l2.74 2.628H4.065a.869.869 0 0 0-.871.87v.581c0 .483.388.871.87.871h6.627l-2.74 2.628a.872.872 0 0 0-.014 1.244l.399.396a.867.867 0 0 0 1.23 0l4.816-4.812a.867.867 0 0 0 0-1.23l-4.816-4.82a.867.867 0 0 0-1.23 0l-.4.396a.876.876 0 0 0 .015 1.248z'
      fill='currentColor'
    />
  </svg>
);
